import { render, staticRenderFns } from "./VisualContentEditor.vue?vue&type=template&id=4b2c19ca&scoped=true&"
import script from "./VisualContentEditor.vue?vue&type=script&lang=ts&"
export * from "./VisualContentEditor.vue?vue&type=script&lang=ts&"
import style0 from "./VisualContentEditor.vue?vue&type=style&index=0&id=4b2c19ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2c19ca",
  null
  
)

export default component.exports